import _ from 'lodash';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { AjaxResponse, AjaxError } from 'rxjs/ajax';
import * as BrowserUtils from '@/utils/browser';
import ApiMixin from '@/mixins/ApiMixin';
import { i18n } from '@/lang';
import Save from '@/components/save/Save.vue';

/**
 * Admin page
 */
@Component({
    components: {
        Save,
    },
})
export default class Redirect extends mixins(ApiMixin) {

    /**
     * Internal state
     */
    state: {[key: string]: any} = {
        state: 'loading',
    };

    /**
     * Created
     */
    mounted() {
        const req$ = this.rocket!.request('url', 'gets', null, {
            $query: {
                id: this.$route.params.id,
                active: true,
            },
            $limit: 1,
        });

        req$.subscribe((res: AjaxResponse) => {
            const { response } = this.rocket!.unpackResponse(res);
            const { results } = response;
            const [url] = results;

            if (!url) {
                this.state.state = 'error';
            } else {
                window.location.replace(url.url);
                // window.location.reload();
            }
        });
    }
}
